import React, { Component } from 'react'
import { connect } from 'react-redux'
import { lang } from '../../strings'
import { getCustomer, updateCustomer, updateAddresses } from './actions'
import CustomerInfo from './customer-info'
import Addresses from './addresses'
import VerifyContactDetailsDialog from './verify-contact-details-dialog'

class Customer extends Component {
  componentWillMount() {
    let { dispatch, customer } = this.props

    if (customer.isEmpty()) {
      dispatch(getCustomer())
    }
  }

  render() {
    let { customer, appState } = this.props
    let { contactDetailsVerified, invoiceAddresses, deliveryAddress } =
      customer.toJS()
    let { networkProgress } = appState.toJS()
    let showVerifyContactDetails =
      !customer.isEmpty() && !contactDetailsVerified

    return (
      <div>
        <h2>{lang.customer.title}</h2>
        <p>{lang.customer.intro}</p>

        {customer.isEmpty() ? null : (
          <CustomerInfo
            customer={customer}
            invoiceAddresses={invoiceAddresses}
            updateCustomerDetails={this.updateCustomerDetails}
          />
        )}
        {customer.isEmpty() ? null : (
          <Addresses
            deliveryAddress={deliveryAddress}
            invoiceAddresses={invoiceAddresses}
            updateAddresses={this.updateAddresses}
          />
        )}

        {showVerifyContactDetails ? (
          <VerifyContactDetailsDialog
            onSubmit={this.updateCustomerDetails}
            customer={customer}
            networkProgress={networkProgress}
          />
        ) : null}
      </div>
    )
  }

  updateCustomerDetails = data => {
    let { dispatch } = this.props
    dispatch(updateCustomer(data))
  }

  updateAddresses = data => {
    let { dispatch } = this.props
    dispatch(updateAddresses(data))
  }
}

function propProvider(reduxState) {
  const { appState, customer } = reduxState

  return {
    appState,
    customer,
  }
}

export default connect(propProvider)(Customer)
